// ticket-app-fe/src/App.js
import React, { useState, useEffect } from 'react';
import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import config from './amplify_outputs.json';
import TicketPurchaseForm from './components/TicketPurchaseForm';
import './App.css';
import './components/TicketPurchaseModal.css';




// Configure Amplify with environment variables
Amplify.configure({
  API: {
    GraphQL: {
      endpoint: process.env.REACT_APP_GRAPHQL_ENDPOINT,
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      defaultAuthorizationType: 'API_KEY',
      apiKey: process.env.REACT_APP_API_KEY
    }
  }
});


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
const client = generateClient({ authMode: 'apiKey' });


function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const eventCode = urlParams.get('event');
  const isEmbed = urlParams.get('embed') === 'true';

  
  // Add console log to verify app is loading
  console.log('App loaded - Event:', eventCode, 'Embed:', isEmbed);
  
  
  const [eventDetails, setEventDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Fetch event details when in embed mode
  useEffect(() => {
    if (isEmbed && eventCode) {
      fetchEventDetails(eventCode);
    }
  }, [isEmbed, eventCode]);
  
  const fetchEventDetails = async (code) => {
    try {
      setLoading(true);
      
      // Try to fetch from your GraphQL API
      
      const response = await client.graphql({
        query: `
          query GetEvent($eventCode: String!) {
            getEvent(eventCode: $eventCode) {
              eventCode
              eventName
              eventDate
              eventTime
              venueName
              venueAddress
              ticketPrice
              status
              ticketsAvailable
            }
          }
        `,
        variables: { eventCode: code }
      });
      setEventDetails(response.data.getEvent);
      
      
      // For testing, use mock data based on event code
     /* const mockEvents = {
        'CS2025': {
          eventCode: 'CS2025',
          eventName: 'Cyber Summit 2025',
          eventDate: 'November 29, 2025',
          eventTime: '9:00 AM - 5:00 PM',
          venueName: 'Houston Convention Center',
          venueAddress: '1001 Avenida de las Americas, Houston, TX',
          ticketPrice: 45,
          status: 'ACTIVE',
          ticketsAvailable: 100
        },
        'GALA2025': {
          eventCode: 'GALA2025',
          eventName: 'BEW Gala Night',
          eventDate: 'November 30, 2025',
          eventTime: '6:00 PM - 11:00 PM',
          venueName: 'The Ballroom at Bayou Place',
          venueAddress: '500 Texas Ave, Houston, TX',
          ticketPrice: 125,
          status: 'ACTIVE',
          ticketsAvailable: 50
        },
        'BEW2025': {
          eventCode: 'BEW2025',
          eventName: 'Black Entrepreneurs Week',
          eventDate: 'November 28-30, 2025',
          eventTime: 'All Day',
          venueName: 'Multiple Venues',
          venueAddress: 'Houston, TX',
          ticketPrice: 200,
          status: 'ACTIVE',
          ticketsAvailable: 75
        }
      };*/
      
     // const event = mockEvents[code];
     const event = response.data.getEvent;
      if (event) {
        setEventDetails(event);
      } else {
        setError('Event not found');
      }
      
      setLoading(false);
    } catch (err) {
      console.error('Error fetching event:', err);
      setError('Failed to load event details');
      setLoading(false);
    }
  };
  
  // If embedded with event code, show the form with fetched details
  if (isEmbed && eventCode) {
    if (loading) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h3>Loading event details...</h3>
        </div>
      );
    }
    
    if (error) {
      return (
        <div style={{ padding: '20px', textAlign: 'center', color: 'red' }}>
          <h3>Error: {error}</h3>
        </div>
      );
    }
    
    if (!eventDetails) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h3>Event not found</h3>
        </div>
      );
    }
    
    // Pass the fetched event details to the form
    return (
      <div className="embed-container" style={{
        padding: '20px',
        maxWidth: '500px',
        margin: '0 auto',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}>
    
        <Elements stripe={stripePromise}>
          <TicketPurchaseForm
            eventCode={eventDetails.eventCode}
            eventName={eventDetails.eventName}
            eventPrice={eventDetails.ticketPrice}
            eventDate={eventDetails.eventDate}
            eventTime={eventDetails.eventTime}
            venueName={eventDetails.venueName}
            venueAddress={eventDetails.venueAddress}
            onSuccess={() => {
              if (window.opener) {
                window.opener.postMessage({
                  type: 'PURCHASE_SUCCESS',
                  eventCode: eventCode,
                  eventName: eventDetails.eventName
                }, '*');
                alert(`Successfully purchased ticket for ${eventDetails.eventName}!`);
              }
            }}
          />
        </Elements>
      </div>
    );
  }
  
  // Your existing regular app view...
  return (
    <div className="App">
      {/* Your existing event buttons */}
    </div>
  );
}

export default App;